import React from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { theme } from 'styled-tools';
import SeoContentHomePage39 from './SeoContentHomePage39';
import { Link } from 'react-router-dom';

function SeoContentHomePage33(props) {
    const { app: {
        brandId
    }, theme: { config } } = props;
    const { showSeoFooterInsidePages } = config

    let domainURL = 'https://www.yolo247.site';

    if (brandId === 32) {
        domainURL = 'https://www.yolo247club.com';
    }
    else if (brandId === 33) {
        domainURL = 'https://m.iw247.com';
    }
    else if (brandId === 34) {
        domainURL = 'https://www.betdaily.club';
    }
    else if (brandId === 39) {
        domainURL = 'https://www.fomo7.co';
    }
    else if (brandId === 40) {
        domainURL = 'https://www.fomo7.xyz';
    }
    else if (brandId === 46) {
        domainURL = 'https://www.fun88.site';
    }
    else if (brandId === 47) {
        domainURL = 'https://www.fun88ind.com';
    }
    const domainName = brandId === 31 || brandId === 32 ? 'Yolo247' : brandId === 33 ? 'iw247' : (brandId === 39 || brandId === 40) ? 'FOMO7' : (brandId === 46 || brandId === 47) ? 'Fun88' : 'Betdaily';

    return (
        <>
            <AccordionWrapper>
                <Accordion>
                    <input type="checkbox" id="section1" className="accordion__input" />
                    <label htmlFor="section1" className="accordion__label"><h1>Online Betting Site in India – Play & Win Big!</h1></label>
                    <div className="accordion__content">
                        <h2>iW247 - India's Top Online Betting Site</h2>
                        <p>Welcome to iW247! We're your complete destination for online betting in India with casino games, live dealers, and sports betting in one secure platform. Join thousands of players who trust us for entertainment and real money wins in India. Enjoy quick payments, generous bonuses, and 24/7 support for all your real money gaming needs.</p>

                        <h2>Why Choose iW247 for Online Betting in India?</h2>
                        <p>iW247 offers India's most seamless betting experience with instant payouts, 24/7 live support in Hindi/English, and exclusive local payment options like UPI and Paytm. Enjoy the best cricket odds, live casino games, and welcome bonus</p>

                        <h3>Safe & Secure: </h3>
                        <p>Advanced protection for your personal and financial details on our trusted real money gaming platform. We use advanced security protocols to protect your bank and personal information ensuring risk free gaming experience.</p>

                        <h3>Properly Licensed: </h3>
                        <p>Operating under legal gaming authorities for legitimate online betting in India. We guarantee fully legal protection and compliant online betting environment for Indian users.</p>

                        <h3>Fast Payments: </h3>
                        <p>Enjoy instant deposits and lightening fast withdrawals making your real money gaming experience smooth and hassle free. Quick deposits and withdrawals via UPI, Paytm, and more for seamless real-money gaming</p>
                        <p>We understand what Indian players want in real money earning games - fair play, fast payouts, and excellent odds.</p>

                        <h2>Casino Games for Real Money Gaming in India</h2>
                        <p>Enjoy live dealer classics like Andar Bahar and Teen Patti, along with 500+ slots, all with secure payments, fast withdrawals, and exclusive bonuses tailored for Indian players.</p>

                        <h3>Live Casino Games</h3>
                        <p>Experience real money gaming from home! Watch professional dealers on HD video streams. Chat with dealers and other players while enjoying these real money earning games in India:</p>

                        <ul>
                            <li><Link to="/live-casino/evolution/roulette">Roulette</Link></li>
                            <li><Link to="/live-casino/evolution/blackjack">Blackjack</Link></li>
                            <li><Link to="/live-casino/betgames/baccarat">Baccarat</Link></li>
                            <li><Link to="/live-casino/7mojos/dragon-tiger">Dragon Tiger</Link></li>
                        </ul>

                        <h3>Slot Games</h3>
                        <p>Try hundreds of exciting real money slots! We have classic fruit machines and modern video slots with stunning graphics. Many slots offer big progressive jackpots that can be won with just one spin on our online betting platform in India! Here are a few suggestions you can try:</p>

                        <ul>
                            <li>Jumanji</li>
                            <li>Blood Suckers 2</li>
                            <li>Fruit Shop</li>
                            <li>Gonzo’s Quest</li>
                            <li>Dead or Alive</li>
                        </ul>

                        <h3>Instant Games</h3>
                        <p>Instant games are ideal for players who love quick thrills in real-money gaming. These games don't have a live dealer and offer instant results, keeping the excitement high. We have many table games, like </p>

                        <ul>
                            <li><Link to="/instant-games/galaxsys/blackjack">Blackjack</Link></li>
                            <li><Link to="/instant-games/galaxsys/sicbo">Sick Bo</Link></li>
                            <li><Link to="/instant-games/spribe/hi-lo">HiLo</Link></li>
                            <li><Link to="/instant-games/galaxsys/roulette-x">Roulette X</Link></li>
                            <li><Link to="/instant-games/turbo-games/crystal-poker">Crystal Poker</Link></li>
                        </ul>

                        <p>Our crash games, like</p>
                        <ul>
                            <li><Link to="/instant-games/spribe/aviator">Aviator</Link></li>
                            <li><Link to="/instant-games/smartsoft/jetx">JetX</Link></li>
                            <li><Link to="/instant-games/aviatrix">Aviatrix</Link></li>
                            <li><Link to="/instant-games/evolution/stock-market">Stock Market</Link></li>
                            <li><Link to="/instant-games/evoplay/penalty-shoot-out">Penalty Shoot-out Street</Link></li>
                        </ul>
                        <p>Let you cash out before the crash for fast-paced, real-money fun.</p>

                        <h2>Sports Betting for Real Money Wins</h2>
                        <p>Enjoy live betting, competitive odds and instant withdrawals via UPI/Paytm with as little as ₹100 deposits.</p>
                        <p>New players get a 400% welcome bonus to boost their bets, plus daily odds boosts on IPL and international matches for bigger potential wins!</p>

                        <h3>Online Cricket Betting in India</h3>
                        <p>Bet on all major cricket tournaments on India's premier online cricket betting platform:</p>
                        <ul>
                            <li>IPL matches</li>
                            <li>World Cup games</li>
                            <li>Test matches</li>
                        </ul>
                        <p>Place bets before games or enjoy <Link to="/betting-exchange/cricket">online cricket betting</Link> in India live as you watch.</p>

                        <h3>Football</h3>
                        <p>Bet on football leagues worldwide through our real money gaming platform:</p>
                        <ul>
                            <li>Premier League</li>
                            <li>La Liga</li>
                            <li>Champions League</li>
                        </ul>
                        <p>Try simple match bets or more complex options for real money earnings.</p>

                        <h3>Other Sports</h3>
                        <p>We offer 25 different sports for complete online betting in India. You can find the available sports in our <Link to="/bti-sportsbook">BTI Sportsbook</Link>. Some of the popular games are</p>
                        <ul>
                            <li><Link to="/betting-exchange/tennis">Tennis</Link></li>
                            <li>Kabaddi</li>
                            <li>Basketball</li>
                            <li>Volleyball</li>
                        </ul>

                        <h2>Bonuses for Real Money Gaming in India</h2>
                        <Table>
                            <thead>
                                <tr>
                                    <td>Bonus Type</td>
                                    <td>Percentage</td>
                                    <td>Key Details</td>
                                    <td>Learn More</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Welcome Bonus</td>
                                    <td>400%</td>
                                    <td>Receive a 38 times bonus on your first deposit. Maximize your initial gameplay by 38X the funds. The maximum amount that can be wagered is 16,000 INR</td>
                                    <td><Link to="/promotions/welcome-bonus">Welcome Bonus</Link></td>
                                </tr>
                                <tr>
                                    <td>Refill Bonus</td>
                                    <td>4%</td>
                                    <td>Get a 4% bonus every time you refill your account. Regular players enjoy consistent rewards.</td>
                                    <td><Link to="/promotions/refill-bonus">Refill Details</Link></td>
                                </tr>
                                <tr>
                                    <td>Cashback Bonus</td>
                                    <td>2%</td>
                                    <td>Earn 2% cashback on your gameplay, helping you recover from losses.</td>
                                    <td><Link to="/promotions/cashback-bonus">Cashback Info</Link></td>
                                </tr>
                                <tr>
                                    <td>Double Cashback</td>
                                    <td>8%</td>
                                    <td>A special promotion offering 8% double cashback on select games and events.</td>
                                    <td><Link to="/promotions/cashback-bonus">Double Cashback</Link></td>
                                </tr>
                                <tr>
                                    <td>Referral Bonus - 1st Deposit</td>
                                    <td>10%</td>
                                    <td>Invite friends and receive benefits when they join.</td>
                                    <td rowSpan={3}><Link to="/promotions/referral-bonus">Referral Program</Link></td>
                                </tr>
                                <tr>
                                    <td>Referral Bonus - 2nd Deposit</td>
                                    <td>5%</td>
                                    <td>Earn 5% when your referred friend makes their second deposit.</td>
                                </tr>
                                <tr>
                                    <td>Referral Bonus - 3rd Deposit</td>
                                    <td>5%</td>
                                    <td>Receive another 5% bonus when your friend makes their third deposit.</td>
                                </tr>
                            </tbody>
                        </Table>
                        <p>Check our <Link to="/promotions/">promotions</Link> page often for the latest online betting offers in India.</p>

                        <h2>Payment Methods</h2>
                        <p>Use popular Indian payment options:</p>
                        <ul>
                            <li>UPI</li>
                            <li>Paytm</li>
                            <li>Google Pay</li>
                            <li>Net Banking</li>
                            <li>Crypto</li>
                        </ul>
                        <p>All transactions are secure, and withdrawals from your real money earnings are processed quickly.</p>

                        <h2>Mobile Online Betting in India</h2>
                        <p>Our site works well on all mobile devices. Use our website or app for real money gaming in India to:</p>
                        <ul>
                            <li>Place bets</li>
                            <li>Play casino games</li>
                            <li>Withdraw real money winnings</li>
                        </ul>

                        <h2>Getting Started with Online Betting in India</h2>
                        <ol>
                            <li><strong>Sign Up:</strong> Create an account in minutes on our real money gaming platform.</li>
                            <li><strong>Deposit:</strong> Add funds and get your welcome bonus to begin real money earning games.</li>
                            <li><strong>Start Playing:</strong> Try casino games or online cricket betting in India.</li>
                        </ol>

                        <h2>Support & Responsible Gaming</h2>
                        <ul>
                            <li>Set betting limits to stay in control of your real money gaming.</li>
                            <li>Get help anytime via Live Chat, email, or WhatsApp.</li>
                        </ul>
                        <p>We encourage fun online betting in India and promote responsible real money gaming.</p>

                        <h2>Download Our Real Money Gaming App</h2>
                        <p>The iW247 mobile app stands out among competitors with its exceptional features and user-friendly design. Here's why thousands of Indian players choose iW247 for their real money gaming needs.</p>

                        <ul>
                            <li>
                                <h3>User-Friendly Design: </h3>
                                <p>iW247 features an easy-to-navigate interface, therefore making it simple for anyone to find their favorite games without confusion or frustration.</p>
                            </li>
                            <li>
                                <h3>Complete Gaming Collection: </h3>
                                <p>From exciting casino games to thrilling sports betting options, moreover, all entertainment is available in one convenient app for Indian players.</p>
                            </li>
                            <li>
                                <h3>Fast and Reliable Performance: </h3>
                                <p>The app loads instantly on all smartphones; additionally, it uses minimal data while still delivering smooth gameplay.</p>
                            </li>
                            <li>
                                <h3>Completely Free to Use: </h3>
                                <p>Unlike many competitors, furthermore, iW247 charges absolutely no hidden fees, thus ensuring a transparent gaming experience.</p>
                            </li>
                            <li>
                                <h3>Secure and Legal Platform: </h3>
                                <p>Your personal information remains protected through advanced encryption; consequently, you can play with confidence on this fully legal Indian betting app.</p>
                            </li>
                            <li>
                                <h3>24/7 Support Available: </h3>
                                <p>Whenever you have questions or concerns, furthermore, the dedicated support team is always ready to help you resolve issues quickly.</p>
                            </li>
                        </ul>

                        <h2>How to Download the iW247 App for Android</h2>
                        <p>iW247, the best betting app in India, offers multiple sports betting options and exciting casino games for Android users. First, the real money games on our platform are both thrilling and rewarding. Moreover, the iW247 app is incredibly easy to download and install on your smartphone. Simply follow these straightforward steps:</p>
                        <p>If using a PC or laptop, </p>
                        <ul>
                            <li>scan the QR code located in the top right corner of the homepage. </li>
                            <li>Then, follow the quick instructions to complete installation on your smartphone.</li>
                        </ul>

                        <p>Alternatively, if browsing the iW247 website on your smartphone, </p>
                        <ul>
                            <li>tap the menu button on the homepage. </li>
                            <li>Next, click on 'Download Android App' and subsequently</li>
                            <li>follow the simple steps to finish installing the iW247 app.</li>
                        </ul>
                        <p>After downloading the app, your next steps are registration and making your first deposit. Finally, you can withdraw your winnings instantly from iW247, truly the best betting app in India.</p>
                        <p><Link to="/app-download">[DOWNLOAD NOW]</Link></p>

                        <h2>Join iW247 Today for Real Money Gaming in India!</h2>
                        <p>Sign up now to get your welcome bonus and start playing real money earning games in India.</p>
                        <p><Link to="/signup">[REGISTER NOW]</Link> <Link to="/login">[START BETTING]</Link></p>

                        <h2>Common Questions About Online Betting in India</h2>
                        <ol>
                            <li>
                                <h3>Is IW247 legal for online betting in India?</h3>
                                <p>Yes, we operate legally and follow all regulations for real money gaming.</p>
                            </li>
                            <li>
                                <h3>What's the minimum deposit to play real money games at iW247?</h3>
                                <p>Start your winning journey with just ₹500! This small deposit gives you full access to all our premium real money games including live casino, slots, and sports betting.</p>
                            </li>
                            <li>
                                <h3>How fast are iW247 withdrawals for real money winnings?</h3>
                                <p>Experience lightning-fast payouts! Most withdrawals process instantly, while all are completed within 24 hours via UPI, Paytm, bank transfer, and other popular Indian payment methods.</p>
                            </li>
                            <li>
                                <h3>Can I practice games before playing with real money at iW247?</h3>
                                <p>Absolutely! We offer free demo versions of our most popular games so you can practice risk-free. Master the rules, test strategies, and build confidence before playing for real money.</p>
                            </li>
                            <li>
                                <h3>Is my personal and financial information secure with iW247?</h3>
                                <p>Your security is our top priority. We use 256-bit SSL encryption, two-factor authentication, and advanced fraud prevention systems to ensure your data remains completely protected at all times.</p>
                            </li>
                        </ol>

                    </div>
                </Accordion>
            </AccordionWrapper>
        </>
    )
}

export default withTheme(withAppContext(SeoContentHomePage33))

//Styled Components
export const Accordion = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: ${theme('palette.seoContenAccordionHeadTextColor')};
    background: ${theme('palette.seoContenAccordionHeadBg')};

    .accordion__label, .accordion__content {
        padding: 14px 20px;
    }

    h1 {
        display: block;
        font-size: 1em;
        font-weight: bold;
        margin: 0;
    }

    h2 {
        display: block;
        font-size: 1.5em;
        font-weight: bold;
    }

    h3 {
        display: block;
        font-size: 1.1em;
        font-weight: bold;
    }

    .number {
        list-style: number;

        li {
            font-weight: bold;
        }
    }

    ul {
        li {
            font-size: 0.91em;
        }
    }

    p {
        margin: 5px 0 10px 0;
        color: ${theme('palette.seoContenAccordionInnerTextColor')};
        font-size: 0.91em;
        font-weight: normal;
        text-transform: none;
    }

    ol, ul {
        li {
            text-transform: none;
            font-size: 0.91em;
        }
    }

    a {
        /* color: #f4a322; */
        color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
    }

    .linkBg {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;
        gap: 5px;

        a {
            background: #1e1e1e;
            border-radius: 5px;
            padding: 5px 10px;
        }
    }

    .textTransformNone {
        text-transform: none;
    }

    .accordion__label{
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${theme('palette.seoContenAccordionHeadTextColor')};
        padding: 20px;
        background: ${theme('palette.seoContenAccordionHeadBg')};
        text-align: center;
        position: relative;
        cursor: pointer;

        :after {
            content: "";
            display: inline-block;
            border-style: solid;
            border-color: ${theme('palette.seoContenAccordionArrowBorder')};
            border-width: 0 2px 2px 0;
            padding: 2.5px;
            vertical-align: middle;
            transition: transform 0.3s;
            transform: ${theme('palette.seoContenAccordionArrowMarkAfter')};
            position: absolute;
            right: 20px;
        }
    }

    .accordion__label:hover{
        background: ${theme('palette.seoContenAccordionHeadHoverBg')};
    }

    .accordion__content {
        background: ${theme('palette.seoContenAccordionContentBg')};
        line-height: 1.6;
        font-size: 0.85em;
        opacity: ${theme('palette.seoContenAccordionContentOpacityOpen')};
        text-transform: capitalize;
        max-height: ${theme('palette.seoContenAccordionContentMaxHeightOpen')};
        padding: ${theme('palette.seoContenAccordionContentPaddingOpen')};
        margin: ${theme('palette.seoContenAccordionContentMarginOpen')};
        overflow-x: ${theme('palette.seoContenAccordionContentOverFlowXOpen')};
        overflow-y: ${theme('palette.seoContenAccordionContentOverFlowYOpen')};
        transition: 0.3s;

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #f5f5f5;
            border-radius: 10px;
        }

        &::-webkit-scrollbar {
          width: 10px;
          background-color: #f5f5f5;
        }
    
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background:gray;
          margin-bottom: 10px;
        }
    }

    .accordion__input {
        display: none;
    }

    .accordion__input:checked ~ .accordion__content {
        opacity: ${theme('palette.seoContenAccordionContentOpacityClosed')};
        max-height: ${theme('palette.seoContenAccordionContentMaxHeightClosed')};
        padding: ${theme('palette.seoContenAccordionContentPaddingClosed')};
        margin: ${theme('palette.seoContenAccordionContentMarginClosed')};
    }

    .accordion__input:checked ~ .accordion__label:after {
        transform: ${theme('palette.seoContenAccordionArrowMarkBefore')};
    }

    .td,th{
        border: 1px solid white;
    }
  
    .table, th, td {
  border: 1px solid white;
  border-collapse: collapse;
}

`;

export const AccordionWrapper = styled.div`
  table,th,td{
    border: 1px solid white;
  }
`;

const Table = styled.table`
    border-collapse: collapse;
    tr, td {
        border: 1px solid white;
        border-collapse: collapse;
        text-align: center;
        padding: 0.5rem 1rem;
    }
`;